import PropTypes from 'prop-types';
import { IconButton, Icon } from '@openedx/paragon';
import { RiEyeLine, RiDownloadLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import FileTypeBadge from './FileTypeBadge';
import messages from '../messages';

const FileTable = ({ files, onPreview, onDownload }) => {
  const { formatMessage } = useIntl();
  return (
    <div
      className="file-table"
      role="table"
      aria-label={formatMessage(messages.tableAriaLabel)}
    >
      <div className="file-table__header" role="row">
        <div className="file-table__cell file-table__cell--name" role="columnheader">
          {formatMessage(messages.columnName)}
        </div>
        <div className="file-table__cell file-table__cell--type" role="columnheader">
          {formatMessage(messages.columnType)}
        </div>
        <div className="file-table__cell file-table__cell--updated" role="columnheader">
          {formatMessage(messages.columnUpdated)}
        </div>
        <div className="file-table__cell file-table__cell--size" role="columnheader">
          {formatMessage(messages.columnSize)}
        </div>
        <div className="file-table__cell file-table__cell--actions" role="columnheader">
          {formatMessage(messages.columnActions)}
        </div>
      </div>

      <div className="file-table__body">
        {files.map((file) => (
          <div className="file-table__row" role="row" key={file.id}>
            <div className="file-table__cell file-table__cell--name" role="cell">{file.name}</div>
            <div className="file-table__cell file-table__cell--type" role="cell">
              <FileTypeBadge type={file.type} />
            </div>
            <div className="file-table__cell file-table__cell--updated" role="cell">{file.updatedAt}</div>
            <div className="file-table__cell file-table__cell--size" role="cell">{file.size}</div>
            <div className="file-table__cell file-table__cell--actions" role="cell">
              {file.type !== 'pptx' && (
                <IconButton
                  src={RiEyeLine}
                  iconAs={Icon}
                  alt={formatMessage(messages.previewFile, { name: file.name })}
                  variant="ghost-secondary"
                  size="inline"
                  onClick={() => onPreview?.(file)}
                />
              )}
              <IconButton
                src={RiDownloadLine}
                iconAs={Icon}
                alt={formatMessage(messages.downloadFile, { name: file.name })}
                variant="ghost-secondary"
                size="inline"
                onClick={() => onDownload?.(file)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

FileTable.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  })).isRequired,
  onPreview: PropTypes.func,
  onDownload: PropTypes.func,
};

FileTable.defaultProps = {
  onPreview: undefined,
  onDownload: undefined,
};

export default FileTable;
